import { accountAPI } from "services";
import dayjs from "dayjs";

import { validateAmount, validateAccountName } from "../Transaction/config";

const amountRules = {
    required: "Amount is required",
    validate: validateAmount
};

const nameRules = {
    maxLength: { value: 50, message: "Name cannot exceed 50 characters" },
    required: "Account Name is required",
    validate: validateAccountName
};

const optionsInt = [
    { value: 1, label: "Daily" },
    { value: 7, label: "Weekly" },
    { value: 33, label: "Last day of Month" },
    { value: 30, label: "⁠Selected Day of Month" },
    // { value: 32, label: "1st day every month" },
    { value: 365, label: "Once a year (same Day)" },
];

const defaultValues = {
    amount: 0,
    accountName: "",
    detail: "",
    date: new Date(),
    phone: "",
    interval: optionsInt[0].value,
    nextTriggerDate: null
};

const calculateNextTriggerDate = (date, interval, editRcTxn) => {
    if (!interval || !date) return null;

    // if selected interval is equal to the previous interval and date is same as previous date, return the previous next trigger date
    if (editRcTxn?.id && interval === editRcTxn.get("interval") && date.getTime() === editRcTxn.get("date")?.getTime()) {
        return editRcTxn.get("nextTriggerDate") || null;
    }

    let d = dayjs(date);
    switch (interval) {
        case 1: d = d.add(0, "day"); break;
        case 7: d = d.add(0, "day"); break;
        case 33: d = d.add(0, "month").endOf("month").startOf("day"); break;
        case 30: d = d.add(0, "month"); break;
        case 32: d = d.add(0, "month").startOf("month"); break;
        case 365: d = d.add(0, "year"); break;
        default: d = d.add(0, "day"); break;
    }
    return d.toDate();
};

const getAccountId = async (isKHATA, accountName, phone, currentAccountId) => {
    if (isKHATA) return currentAccountId;
    if (!accountName) throw new Error("Account Name is required");

    let myAccount = await accountAPI.getAccountByName(accountName);
    if (!myAccount) {
        myAccount = await accountAPI.createAccount(accountName, phone || "");
        if (!myAccount) throw new Error("New account creation failed.");
    }
    return myAccount.id;
};

export { amountRules, nameRules, optionsInt, defaultValues, calculateNextTriggerDate, getAccountId };